import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { MentorGridDataService } from 'common/services/data-services/admin/mentor/mentor-grid-data.service';
import { MentorModel } from 'common/models/page-models/mentor/mentor-data-model';
import { MentorGridMetaModel } from 'common/models/page-models/mentor/mentor-grid-meta-model';
import { MentorListingModel } from 'common/models/page-models/mentor/mentor-grid-model';


 
@Injectable({
    providedIn: 'root'
})
export class MentorGridWidgetService extends GridWidgetService<MentorModel, MentorListingModel> {
    constructor(protected override ds: MentorGridDataService, protected systemService: SystemService) {
        super(ds);
    }
 
    getMetaModel(): MetaModel {
        const meta = new MentorGridMetaModel().getMetaModel();
        return meta;
    }
}